import type { ProfessorImpactFormValues } from "./types";

export const PROFESSOR_IMPACT_FORM_DEFAULTS: ProfessorImpactFormValues = {
  firstName: "",
  lastName: "",
  email: "",
  institution: "",
  website: "",
  useCase: "",
  studentAccess: "",
  featuredConsent: false,
  termsAgreed: false,
};

export const fieldConfig = {
  firstName: {
    name: "firstName" as const,
    required: true,
  },
  lastName: {
    name: "lastName" as const,
    required: true,
  },
  email: {
    name: "email" as const,
    required: true,
  },
  institution: {
    name: "institution" as const,
    required: true,
  },
  website: {
    name: "website" as const,
    required: true,
  },
  useCase: {
    name: "useCase" as const,
    required: true,
  },
  studentAccess: {
    name: "studentAccess" as const,
    required: true,
  },
  featuredConsent: {
    name: "featuredConsent" as const,
    required: false,
  },
  termsAgreed: {
    name: "termsAgreed" as const,
    required: true,
  },
};
